import { render, staticRenderFns } from "./FiltrosDeVenda.vue?vue&type=template&id=24781f59&lang=pug"
import script from "./FiltrosDeVenda.vue?vue&type=script&lang=js"
export * from "./FiltrosDeVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports